import React from "react";
import { FaWhatsapp } from "react-icons/fa";

const FloatingWhatsAppButton = () => {
  return (
    <a
      href="https://api.whatsapp.com/send?phone=+14698799867&text=Hi%20Adore%20Bijoux%20Jewelers!%20I%20have%20a%20few%20queries.%20Could%20you%20please%20help%20me%20out?"
      className="floating-whatsapp"
      target="_blank"
      rel="noopener noreferrer"
    >
      <FaWhatsapp size={28} style={{cursor:"pointer"}} />
    </a>
  );
};

export default FloatingWhatsAppButton;
